import { ReactNode } from 'react'

interface AuthLayoutProps {
  children: ReactNode
}

export default function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="relative min-h-screen">
      {/* Grid background */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#00000008_1px,transparent_1px),linear-gradient(to_bottom,#00000008_1px,transparent_1px)] bg-[size:3rem_3rem]" />
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-teal-50/50 via-white/80 to-violet-50/50 dark:from-teal-950/30 dark:via-slate-950/80 dark:to-violet-950/30" />
      </div>

      {/* Content */}
      <div className="flex min-h-screen items-center justify-center bg-background">
        {children}
      </div>
    </div>
  )
}
